export default function Attribution() {
   return (
      <footer className="attribution">
         <p>developed by <a href="https://travolgi.it" target="_blank" rel="noreferrer">Travolgi</a></p>
      </footer>
   );
}